import React from 'react';
import { createPortal } from 'react-dom';

type Properties = {
    alignItems?: 'center' | 'flex-end';
};

export default function Modal(props: React.PropsWithChildren<Properties>) {
    const modalStyle = {
        alignItems: props.alignItems || 'center'
    };

    return createPortal(
        <div className="modal" style={modalStyle}>
            <div className="modal_inner">
                {props.children}
            </div>
        </div>,
        document.getElementById('modal_root') as HTMLElement
    );
}